import { render, staticRenderFns } from "./SponsorBar.vue?vue&type=template&id=79e8b0d9&"
import script from "./SponsorBar.vue?vue&type=script&lang=js&"
export * from "./SponsorBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports